import React from 'react';
import { createPortal } from 'react-dom';
import Modal from 'react-bootstrap/Modal';
import Tag from './Tag';
import Chip from './Chip';
import EmptyState from './EmptyState';
import { fmtDateISO, fmtTime, safeParseDate, money } from '../utils';

export default function ActivityDetailModal({ show, onHide, detail, removeActivity }) {
  if (!show || typeof document === 'undefined' || !document.body) return null;
  return createPortal(
    <div key={`activity-detail-${detail?.id}`} className="default-pages-calendar">
      <Modal show onHide={onHide} centered size="lg" className="default-pages-calendar">
        <Modal.Header closeButton>
          <Modal.Title>Activity Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!detail ? (
            <EmptyState title="Not found" subtitle="This activity no longer exists." />
          ) : (
            <div className="detail">
              <div className="detailHead">
                <div className="detailTitle">{detail.title}</div>
                <Tag t={detail.type} />
              </div>
              <div className="detailMeta">
                {(() => { const d = safeParseDate(detail.at); return (
                  <>
                    <Chip k="date" v={fmtDateISO(d)} />
                    <Chip k="time" v={fmtTime(d)} />
                    {detail.amount != null ? <Chip k="amount" v={money(detail.amount, detail.currency)} /> : null}
                  </>
                ); })()}
              </div>
              {detail.note ? <div className="note">{detail.note}</div> : null}
              {detail.meta && (
                <div className="metaGrid">
                  {Object.entries(detail.meta).map(([k, v]) => (
                    <div key={k} className="metaBox">
                      <div className="metaK">{k}</div>
                      <div className="metaV">{v}</div>
                    </div>
                  ))}
                </div>
              )}
              <div className="detailActions">
                <button type="button" className="danger" onClick={() => removeActivity(detail.id)}>Remove</button>
                <button type="button" className="ghost" onClick={onHide}>Close</button>
              </div>
              <div className="detailHint">
                <span className="muted">Next step:</span> connect this view to real events (login logs, orders, wallet tx, password changes).
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>,
    document.body
  );
}
